/* eslint-disable no-param-reassign */
// @ts-nocheck
export default {
    POST_WORKER_FEE_PER_STORE_GROUP: ({ workerFeePerStoreGroupList }, data) => {
        workerFeePerStoreGroupList[workerFeePerStoreGroupList.length] = data;
    },
    GET_WORKER_FEE_PER_STORE_GROUP_LIST: (state, data) => {
        state.workerFeePerStoreGroupList = data;
    },
    PUT_WORKER_FEE_PER_STORE_GROUP: (state, data) => {
        const index = state.workerFeePerStoreGroupList.findIndex((group) => group.id === data.id);
        state.workerFeePerStoreGroupList[index] = data;
    },
    DELETE_WORKER_FEE_PER_STORE_GROUP: (state, data) => {
        state.workerFeePerStoreGroupList = data;
    },
    POST_WORKER_FEE_PER_STORE_GROUP_OPTION: ({ workerFeePerStoreGroupOptionList }, data) => {
        workerFeePerStoreGroupOptionList[workerFeePerStoreGroupOptionList.length] = data;
    },
    GET_WORKER_FEE_PER_STORE_GROUP_OPTION_LIST: (state, data) => {
        state.workerFeePerStoreGroupOptionList = data;
    },
    PUT_WORKER_FEE_PER_STORE_GROUP_OPTION: (state, data) => {
        const index = state.workerFeePerStoreGroupOptionList.findIndex((option) => option.id === data.id);
        state.workerFeePerStoreGroupOptionList[index] = data;
    },
    DELETE_WORKER_FEE_PER_STORE_GROUP_OPTION: (state, data) => {
        state.workerFeePerStoreGroupOptionList = data;
    },
    SET_SELECTED_FEE_GROUP: (state, data) => {
        state.selectedFeeGroup = data;
    },
    // 다이얼로그 핸들링
    SET_OPEN_EDIT_GROUP_DIALOG: (state, isOpen) => {
        state.isEditGroupDialogOpen = isOpen;
    },
    SET_OPEN_EDIT_OPTION_DIALOG: (state, isOpen) => {
        state.isEditOptionDialogOpen = isOpen;
    },
    SET_EDIT_GROUP_ITEM: (state, item) => {
        state.editGroupItem = item;
    },
    SET_EDIT_OPTION_ITEM: (state, item) => {
        state.editOptionItem = item;
    },
    // 초기화
    CLEAR_WORKER_FEE_PER_STORE_GROUP_LIST: (state) => {
        state.workerFeePerStoreGroupList = [];
    },
    CLEAR_WORKER_FEE_PER_STORE_GROUP_OPTION_LIST: (state) => {
        state.workerFeePerStoreGroupOptionList = [];
    },
    CLEAR_SELECTED_FEE_GROUP: (state) => {
        state.selectedFeeGroup = null;
    },
    // Publish
    PUBLISH_WORKER_FEE_PER_STORE_GROUP_DELETED: () => {
        // subscribe mutation only
    },
};
